// extracted by mini-css-extract-plugin
export default {"lng":"LanguageSwitcher_lng__tWztc"};